<template>
  <div class="flex flex-wrap">
    <div class="w-full lg:w-5/12 lg:fixed bg-secondary md:min-h-screen  flex flex-column justify-center items-center pb-8">
      <v-lazy-image v-bind:src="product.image" class="mx-auto mx-auto w-10/12" />
    </div>
    <div class="w-full md:min-h-screen bg-lightgray pb-8 lg:w-7/12 lg:ml-[41.666667%] text-5xl p-10 md:p-14 text-primary relative">

            <span @click="displayProduct"
                  class="hidden lg:inline-block close font-montserrat absolute top-8 right-4 md:top-8 md:right-8 cursor-pointer">
                    <svg width="40px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 50" enable-background="new 0 0 50 50" xml:space="preserve">
                    <path fill="#231F20" d="M9.016,40.837c0.195,0.195,0.451,0.292,0.707,0.292c0.256,0,0.512-0.098,0.708-0.293l14.292-14.309
                        l14.292,14.309c0.195,0.196,0.451,0.293,0.708,0.293c0.256,0,0.512-0.098,0.707-0.292c0.391-0.39,0.391-1.023,0.001-1.414
                        L26.153,25.129L40.43,10.836c0.39-0.391,0.39-1.024-0.001-1.414c-0.392-0.391-1.024-0.391-1.414,0.001L24.722,23.732L10.43,9.423
                        c-0.391-0.391-1.024-0.391-1.414-0.001c-0.391,0.39-0.391,1.023-0.001,1.414l14.276,14.293L9.015,39.423
                        C8.625,39.813,8.625,40.447,9.016,40.837z" id="id_101"></path>
                    </svg>
            </span>

      <h1 class="font-black text-4xl md:text-h1-product leading-none pr-8">{{ product.reference }}</h1>

      <div v-if="product.description">
        <h4 class="uppercase text-primary">Un mot sur la maison</h4>
        <p>{{product.description}}</p>
      </div>

      <!--div v-if="product.innovation">
        <h4 class="uppercase text-primary">Innovation</h4>
        <p>{{product.innovation}}</p>
      </div-->

      <div v-if="product.caracteristique">
        <h4 class="uppercase text-primary">Élaboration / Caractéristique</h4>
        <p>{{product.caracteristique}}</p>
        <p  v-if="product.innovation" class="mt-4">{{product.innovation}}</p>
      </div>

      <div class="bg-whtie flex flex-wrap mt-14">
        <div v-for="(categorie, name) in product.categories"
             :key="name"
             class="w-full md:w-4/12 bg-white"
        >
          <div class="categorie-fiche-item">
            <img v-bind:src="categorie.image" alt="" />
            <div class="category-name px-8">{{ name }}</div>
            <div class="category-labels px-4">{{categorie.childs.join(', ')}}</div>
          </div>
        </div>
      </div>
        <div v-if="product.site">
            <a target="_blank" class="btn" :href="product.site" v-html="'Visiter le site'"></a>
        </div>
    </div>

  </div>
</template>

<script>
import VLazyImage from "v-lazy-image"
export default {
 props:{
   product:{
    type:[Array, Object],
    required:true
   }
 },
  components:{
    VLazyImage
  },
  name: "productPage",
  methods:{
     async displayProduct(){
         this.$emit('displayProductPage', false)
     }
 }
}
</script>

<style scoped>
h4 {
    font-size: 16px;
    font-family: 'Montserrat';
    font-weight: bold;
    margin-top: 3rem;
    padding-bottom: 1rem;
    margin-bottom: 2rem;
    border-bottom: 1px solid #ddd;
}
p {
    font-size: 1rem;
    text-transform: initial;
    line-height: 1.5;
}
.categorie-fiche-item img {
    width: 40px;
    margin-bottom: 1rem;
}
.categorie-fiche-item:hover .category-labels {
    display: flex;
}
.btn {
    font-size: 12px;
    text-transform: uppercase;
    font-family: Montserrat, sans-serif;
    padding:18px 16px;
    border:1px solid #614537;
    color: #614537;
}
.btn:hover {
    background-color: #e16600;
    color: white;
    border:1px solid #e16600
}
</style>